import type { NormalizedPromptPayId, PromptPayIdType } from './types';

const DIGIT_ONLY = /^\d+$/;
const THAI_MOBILE = /^(?:\+66|66|0)\d{9}$/;

export function maskPromptPayId(input: string): string {
  const digits = input.replace(/\D/g, '');
  return digits.length >= 4 ? `••••${digits.slice(-4)}` : '••••';
}

export function normalizePromptPayId(
  input: string,
  type: PromptPayIdType,
): NormalizedPromptPayId {
  const value = input.trim();
  if (!value) {
    throw new Error('promptpayId is required');
  }

  if (type === 'mobile') {
    if (!THAI_MOBILE.test(value)) {
      throw new Error(
        'promptpayId must be a Thai mobile number in 0xxxxxxxxx, 66xxxxxxxxx, or +66xxxxxxxxx form',
      );
    }
    const normalized = value.startsWith('+66')
      ? `0066${value.slice(3)}`
      : value.startsWith('66')
        ? `0066${value.slice(2)}`
        : `0066${value.slice(1)}`;
    if (normalized.length !== 13 || !DIGIT_ONLY.test(normalized)) {
      throw new Error('promptpayId normalization failed');
    }
    return { value: normalized, type };
  }

  if (!/^\d{13}$/.test(value)) {
    throw new Error('promptpayId must be a 13-digit Thai national ID');
  }

  return { value, type };
}
